var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImportIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.998,
    height: 13.998,
    viewBox: "0 0 11.998 13.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document--import",
    transform: "translate(-4 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21048",
    "data-name": "Path 21048",
    d: "M19.5,17H12.915L14.2,15.7l-.7-.7L11,17.5,13.5,20l.7-.7L12.915,18H19.5Z",
    transform: "translate(-3.5 -6.501)",
    fill: "#203662"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21049",
    "data-name": "Path 21049",
    d: "M14,8V6a.5.5,0,0,0-.145-.355l-3.5-3.5A.5.5,0,0,0,10,2H5A1,1,0,0,0,4,3V15a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V14H13v1H5V3H9V6a1,1,0,0,0,1,1h3V8ZM10,6V3.2L12.794,6Z",
    transform: "translate(0 0)",
    fill: "#203662"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportIcon);
export default __webpack_public_path__ + "static/media/Import-Icon.9c02ea5324b1fe3570a3f81fd2b015d0.svg";
export { ForwardRef as ReactComponent };